module.exports = __webpack_public_path__ + "static/media/timer-red.4bed4d42.svg";